/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/search/static/search-bar/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "+66z":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ePw5");


/***/ }),

/***/ "1dWh":
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ "4XOI":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "#page-header .header-main__search-wrapper{display:block;width:100%;top:106px;left:0;position:fixed;z-index:100}@media (min-width:768px){#page-header .header-main__search-wrapper{max-width:500px;margin:0 20px;position:relative;top:0;z-index:100}}@media (min-width:1200px){#page-header .header-main__search-wrapper{max-width:600px}}#page-header .header-main__search{display:block;position:relative;margin:0}#page-header .header-main__search-input{outline:0;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;margin:0;padding:13px 90px 13px 15px;font-family:Gotham A,Gotham B,sans-serif;font-size:14px;background-color:transparent;-webkit-box-shadow:none;box-shadow:none;outline-color:transparent;background-color:#fff;border:1px solid #003767;-webkit-appearance:none;-moz-appearance:none;border-radius:0}#page-header .header-main__search-input:focus{-webkit-box-shadow:none;box-shadow:none;border-color:#003767}#page-header .header-main__search-input:focus+.header-main__search-button{color:#fff;background-color:#003767}#page-header .header-main__search-input::-webkit-input-placeholder{font-style:italic}#page-header .header-main__search-input::-ms-clear{display:none}#page-header .header-main__search-clear{display:inline-block;position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);right:100px;height:12px;width:12px;opacity:.4;cursor:pointer}#page-header .header-main__search-clear:focus,#page-header .header-main__search-clear:hover{opacity:1}#page-header .header-main__search-button{position:absolute;padding:10px 15px;height:100%;top:50%;right:0;font-size:14px;font-weight:600;cursor:pointer;color:#003767;line-height:1em;text-transform:uppercase;background-color:transparent;-webkit-transform:translateY(-50%);transform:translateY(-50%);outline:none;border:none;-webkit-transition:color .4s ease,background-color .4s ease;transition:color .4s ease,background-color .4s ease}#page-header .header-main__search-input:focus+svg+.header-main__search-button{color:#fff;background-color:#003767}#page-header .header-main__search-input:placeholder-shown+svg{opacity:0}#page-header .header-main__search-button--results{margin-top:10px;padding:10px;width:100%;font-size:12px;font-weight:500;color:#fff;text-transform:uppercase;cursor:pointer;background-color:#222;outline:none;border:none;-webkit-transition:all .4s ease;transition:all .4s ease}#page-header .header-main__icons{padding-left:5px;min-width:75px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:distribute;justify-content:space-around;font-weight:500}@media (min-width:768px){#page-header .header-main__icons{min-width:90px}}@media (min-width:992px){#page-header .header-main__icons{max-width:100%}}#page-header .header-main__icon--menu{display:none;text-align:left;padding:4px;margin-right:20px;font-size:25px;cursor:pointer;background:none;border:none;color:#000}@media (max-width:767px){#page-header .header-main__icon--menu{margin-right:0;min-width:75px}}@media (max-width:1199px){#page-header .header-main__icon--menu{display:block}}#page-header .header-main__icon--menu:after{content:\"\\F197\";font-size:25px;font-family:Material-Design-Iconic-Font}#page-header .header-main__icon--menu:focus{outline:none}#page-header .header-main__icon--cart{min-width:30px;display:inline-block;color:#222;font-size:11px;line-height:1.2em;text-align:center;text-decoration:none}@media (min-width:768px){#page-header .header-main__icon--cart{min-width:40px}}@media (min-width:992px){#page-header .header-main__icon--cart{min-width:90px;margin:0 10px;text-align:left}}#page-header .header-main__icon--cart:focus,#page-header .header-main__icon--cart:hover{text-decoration:none}#page-header .header-main__icon--cart:before{content:\"\\F1CB\";display:block;color:#003767;font-size:22px;font-family:Material-Design-Iconic-Font;line-height:1em}@media (min-width:768px){#page-header .header-main__icon--cart:before{font-size:28px}}@media (min-width:992px){#page-header .header-main__icon--cart:before{float:left;margin-right:6px}}#page-header .header-main__icon--cart span{display:none}@media (min-width:992px){#page-header .header-main__icon--cart span{display:block}}#page-header .header-main__icon--fav{min-width:30px;display:inline-block;color:#222;font-size:11px;line-height:1.2em;text-align:center;text-decoration:none}@media (min-width:768px){#page-header .header-main__icon--fav{min-width:40px}}@media (min-width:992px){#page-header .header-main__icon--fav{min-width:95px;margin:0 10px;text-align:left}}#page-header .header-main__icon--fav:focus,#page-header .header-main__icon--fav:hover{text-decoration:none}#page-header .header-main__icon--fav:before{content:\"\\F15F\";display:block;color:#003767;font-size:22px;font-family:Material-Design-Iconic-Font;vertical-align:middle;line-height:1em}@media (min-width:768px){#page-header .header-main__icon--fav:before{font-size:28px}}@media (min-width:992px){#page-header .header-main__icon--fav:before{float:left;margin-right:6px}}#page-header .header-main__icon--fav span{display:none}@media (min-width:992px){#page-header .header-main__icon--fav span{display:block}}.search-result-wrapper{display:none;position:absolute;left:0;padding:20px;width:100%;background-color:#fff;z-index:100}.search-result__section{margin-bottom:20px}.search-result__section-title{font-size:12px;font-weight:600;text-transform:uppercase}.search-result__list--text{margin:0;padding:0;list-style:none}.search-result__list-item--text{padding:3px 0;font-size:12px;border-bottom:1px solid #ddd}.search-result__list-item--text>a{color:#222;text-decoration:none;display:block}.search-result__list-item--text:last-child{border-bottom:none}.search-result__list-item--text:hover{background-color:#f4f4f4}.search-result__list--block{margin:0;padding:0;list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.search-result__list-item--block{width:50%;padding-right:20px}@media (min-width:576px){.search-result__list-item--block{width:25%}}.search-result__list-item--block>a{color:#222;text-decoration:none}.search-result__list-item-img{margin:0 0 10px;width:100%;overflow:hidden}.search-result__list-item-img img{width:100%;height:auto;display:block}.search-result__list-item-name{overflow:hidden}.search-result__list-item-name,.search-result__list-item-price1{margin:0 0 10px;font-size:12px;font-weight:500;line-height:1.4em}.search-result__list-item-price1{color:#003767}.search-result__list-item-price1 span{display:block}.search-result__list-item-price2{font-size:12px;line-height:1.4em;color:#003767;color:#999}.search-result__list-item-price2 span{display:block}", ""]);

// exports


/***/ }),

/***/ "6MiT":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "MTIv":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__("mJPh");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "NkRn":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "NzuB":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Emitter = function () {
  function Emitter() {
    classCallCheck(this, Emitter);

    this.listeners = {};
  }

  createClass(Emitter, [{
    key: 'addEventListener',
    value: function addEventListener(type, callback) {
      if (!(type in this.listeners)) {
        this.listeners[type] = [];
      }
      this.listeners[type].push(callback);
    }
  }, {
    key: 'removeEventListener',
    value: function removeEventListener(type, callback) {
      if (!(type in this.listeners)) {
        return;
      }
      var stack = this.listeners[type];
      for (var i = 0, l = stack.length; i < l; i++) {
        if (stack[i] === callback) {
          stack.splice(i, 1);
          return;
        }
      }
    }
  }, {
    key: 'dispatchEvent',
    value: function dispatchEvent(event) {
      var _this = this;

      if (!(event.type in this.listeners)) {
        return;
      }
      var debounce = function debounce(callback) {
        setTimeout(function () {
          return callback.call(_this, event);
        });
      };
      var stack = this.listeners[event.type];
      for (var i = 0, l = stack.length; i < l; i++) {
        debounce(stack[i]);
      }
      return !event.defaultPrevented;
    }
  }]);
  return Emitter;
}();

var AbortSignal = function (_Emitter) {
  inherits(AbortSignal, _Emitter);

  function AbortSignal() {
    classCallCheck(this, AbortSignal);

    var _this2 = possibleConstructorReturn(this, (AbortSignal.__proto__ || Object.getPrototypeOf(AbortSignal)).call(this));

    _this2.aborted = false;
    _this2.onabort = null;
    return _this2;
  }

  createClass(AbortSignal, [{
    key: 'toString',
    value: function toString() {
      return '[object AbortSignal]';
    }
  }, {
    key: 'dispatchEvent',
    value: function dispatchEvent(event) {
      if (event.type === 'abort') {
        this.aborted = true;
        if (typeof this.onabort === 'function') {
          this.onabort.call(this, event);
        }
      }

      get(AbortSignal.prototype.__proto__ || Object.getPrototypeOf(AbortSignal.prototype), 'dispatchEvent', this).call(this, event);
    }
  }]);
  return AbortSignal;
}(Emitter);

var AbortController = function () {
  function AbortController() {
    classCallCheck(this, AbortController);

    this.signal = new AbortSignal();
  }

  createClass(AbortController, [{
    key: 'abort',
    value: function abort() {
      var event = void 0;
      try {
        event = new Event('abort');
      } catch (e) {
        if (typeof document !== 'undefined') {
          // For Internet Explorer 11:
          event = document.createEvent('Event');
          event.initEvent('abort', false, false);
        } else {
          // Fallback where document isn't available:
          event = {
            type: 'abort',
            bubbles: false,
            cancelable: false
          };
        }
      }
      this.signal.dispatchEvent(event);
    }
  }, {
    key: 'toString',
    value: function toString() {
      return '[object AbortController]';
    }
  }]);
  return AbortController;
}();

if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
  // These are necessary to make sure that we get correct output for:
  // Object.prototype.toString.call(new AbortController())
  AbortController.prototype[Symbol.toStringTag] = 'AbortController';
  AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
}

/**
 * Note: the "fetch.Request" default value is available for fetch imported from
 * the "node-fetch" package and not in browsers. This is OK since browsers
 * will be importing umd-polyfill.js from that path "self" is passed the
 * decorator so the default value will not be used (because browsers that define
 * fetch also has Request). One quirky setup where self.fetch exists but
 * self.Request does not is when the "unfetch" minimal fetch polyfill is used
 * on top of IE11; for this case the browser will try to use the fetch.Request
 * default value which in turn will be undefined but then then "if (Request)"
 * will ensure that you get a patched fetch but still no Request (as expected).
 * @param {fetch, Request = fetch.Request}
 * @returns {fetch: abortableFetch, Request: AbortableRequest}
 */
function abortableFetchDecorator(patchTargets) {
  if ('function' === typeof patchTargets) {
    patchTargets = { fetch: patchTargets };
  }
  var _patchTargets = patchTargets,
      fetch = _patchTargets.fetch,
      _patchTargets$Request = _patchTargets.Request,
      NativeRequest = _patchTargets$Request === undefined ? fetch.Request : _patchTargets$Request,
      _patchTargets$AbortCo = _patchTargets.AbortController,
      NativeAbortController = _patchTargets$AbortCo === undefined ? AbortController : _patchTargets$AbortCo;


  var Request = NativeRequest;
  // Note that the "unfetch" minimal fetch polyfill defines fetch() without
  // defining window.Request, and this polyfill need to work on top of unfetch
  // so the below feature detection is wrapped in if (Request)
  if (Request) {
    // Do feature detecting
    var controller = new NativeAbortController();
    var signal = controller.signal;
    var request = new Request('/', { signal: signal });

    // Browser already supports abortable fetch (like FF v57 and fetch-polyfill)
    if (request.signal) {
      return { fetch: fetch, Request: Request };
    }

    Request = function Request(input, init) {
      var request = new NativeRequest(input, init);
      if (init && init.signal) {
        request.signal = init.signal;
      }
      return request;
    };
    Request.prototype = NativeRequest.prototype;
  }

  var realFetch = fetch;
  var abortableFetch = function abortableFetch(input, init) {
    var signal = Request && Request.prototype.isPrototypeOf(input) ? input.signal : init ? init.signal : undefined;

    if (signal) {
      var abortError = void 0;
      try {
        abortError = new DOMException('Aborted', 'AbortError');
      } catch (err) {
        // IE 11 does not support calling the DOMException constructor, use a
        // regular error object on it instead.
        abortError = new Error('Aborted');
        abortError.name = 'AbortError';
      }

      // Return early if already aborted, thus avoiding making an HTTP request
      if (signal.aborted) {
        return Promise.reject(abortError);
      }

      // Turn an event into a promise, reject it once `abort` is dispatched
      var cancellation = new Promise(function (_, reject) {
        signal.addEventListener('abort', function () {
          return reject(abortError);
        }, { once: true });
      });

      // Return the fastest promise (don't need to wait for request to finish)
      return Promise.race([cancellation, realFetch(input, init)]);
    }

    return realFetch(input, init);
  };

  return { fetch: abortableFetch, Request: Request };
}

(function (self) {

  if (self.AbortController) {
    return;
  }

  self.AbortController = AbortController;
  self.AbortSignal = AbortSignal;

  if (!self.fetch) {
    console.warn('fetch() is not available, cannot install abortcontroller-polyfill');
    return;
  }

  var _abortableFetch = abortableFetchDecorator(self),
      fetch = _abortableFetch.fetch,
      Request = _abortableFetch.Request;

  self.fetch = fetch;
  self.Request = Request;
})(typeof self !== 'undefined' ? self : global);

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "O4Lo":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("yCNF"),
    now = __webpack_require__("RVHk"),
    toNumber = __webpack_require__("kxzG");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "RVHk":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "Sn7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SVGNamespace */
/* unused harmony export preventDefault */
/* unused harmony export stopPropagation */
/* unused harmony export Fragment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createElement; });
/* unused harmony export createElement */
//https://github.com/glixlur/jsx-dom

const __assign = Object.assign;

var keys = Object.keys;
function isBoolean(val) {
  return typeof val === "boolean";
}
function isElement(val) {
  return val && typeof val.nodeType === "number";
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return typeof val === "object" ? val !== null : isFunction(val);
}
// tslint:disable-next-line:ban-types
function isFunction(val) {
  return typeof val === "function";
}
function isArrayLike(obj) {
  return (
    isObject(obj) &&
    typeof obj.length === "number" &&
    typeof obj.nodeType !== "number"
  );
}

var SVGNamespace = "http://www.w3.org/2000/svg";
var XLinkNamespace = "http://www.w3.org/1999/xlink";
var XMLNamespace = "http://www.w3.org/XML/1998/namespace";
function preventDefault(event) {
  event.preventDefault();
  return event;
}
function stopPropagation(event) {
  event.stopPropagation();
  return event;
}
// https://facebook.github.io/react/docs/jsx-in-depth.html#booleans-null-and-undefined-are-ignored
// Emulate JSX Expression logic to ignore certain type of children or className.
function isVisibleChild(value) {
  return !isBoolean(value) && value !== null;
}
/**
 * Convert a `value` to a className string.
 * `value` can be a string, an array or a `Dictionary<boolean>`.
 */
function className(value) {
  if (Array.isArray(value)) {
    return value
      .map(className)
      .filter(Boolean)
      .join(" ");
  } else if (isObject(value)) {
    return keys(value)
      .filter(function(k) {
        return value[k];
      })
      .join(" ");
  } else if (isVisibleChild(value)) {
    return "" + value;
  } else {
    return "";
  }
}
var svg = {
  animate: 0,
  circle: 0,
  clipPath: 0,
  defs: 0,
  desc: 0,
  ellipse: 0,
  feBlend: 0,
  feColorMatrix: 0,
  feComponentTransfer: 0,
  feComposite: 0,
  feConvolveMatrix: 0,
  feDiffuseLighting: 0,
  feDisplacementMap: 0,
  feDistantLight: 0,
  feFlood: 0,
  feFuncA: 0,
  feFuncB: 0,
  feFuncG: 0,
  feFuncR: 0,
  feGaussianBlur: 0,
  feImage: 0,
  feMerge: 0,
  feMergeNode: 0,
  feMorphology: 0,
  feOffset: 0,
  fePointLight: 0,
  feSpecularLighting: 0,
  feSpotLight: 0,
  feTile: 0,
  feTurbulence: 0,
  filter: 0,
  foreignObject: 0,
  g: 0,
  image: 0,
  line: 0,
  linearGradient: 0,
  marker: 0,
  mask: 0,
  metadata: 0,
  path: 0,
  pattern: 0,
  polygon: 0,
  polyline: 0,
  radialGradient: 0,
  rect: 0,
  stop: 0,
  svg: 0,
  switch: 0,
  symbol: 0,
  text: 0,
  textPath: 0,
  tspan: 0,
  use: 0,
  view: 0
};
function Fragment(attr) {
  var fragment = document.createDocumentFragment();
  appendChildren(attr.children, fragment);
  return fragment;
}
function createElement(tag, attr) {
  var children = [];
  for (var _i = 2; _i < arguments.length; _i++) {
    children[_i - 2] = arguments[_i];
  }
  attr = attr || {};
  if (!attr.namespaceURI && svg[tag] === 0) {
    attr = __assign({}, attr, { namespaceURI: SVGNamespace });
  }
  var node;
  if (isString(tag)) {
    node = attr.namespaceURI
      ? document.createElementNS(attr.namespaceURI, tag)
      : document.createElement(tag);
    attributes(attr, node);
    appendChildren(children, node);
  } else if (isFunction(tag)) {
    // Custom elements.
    node = tag(__assign({}, attr, { children: children }));
  }
  if (isFunction(attr.ref)) {
    attr.ref(node);
  }
  return node;
}
function appendChild(child, node) {
  if (isArrayLike(child)) {
    appendChildren(child, node);
  } else if (isString(child) || isNumber(child)) {
    node.appendChild(document.createTextNode(child));
  } else if (child === null) {
    node.appendChild(document.createComment(""));
  } else if (isElement(child)) {
    node.appendChild(child);
  }
}
function appendChildren(children, node) {
  for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
    var child = children_1[_i];
    appendChild(child, node);
  }
  return node;
}
function normalizeAttribute(s) {
  return s.replace(/[A-Z\d]/g, function(match) {
    return ":" + match.toLowerCase();
  });
}
function attribute(key, value, node) {
  {
    switch (key) {
      case "xlinkActuate":
      case "xlinkArcrole":
      case "xlinkHref":
      case "xlinkRole":
      case "xlinkShow":
      case "xlinkTitle":
      case "xlinkType":
        node.setAttributeNS(XLinkNamespace, normalizeAttribute(key), value);
        return;
      case "xmlnsXlink":
        node.setAttribute(normalizeAttribute(key), value);
        return;
      case "xmlBase":
      case "xmlLang":
      case "xmlSpace":
        node.setAttributeNS(XMLNamespace, normalizeAttribute(key), value);
        return;
    }
  }
  switch (key) {
    case "dataset":
      for (var _i = 0, _a = keys(value || {}); _i < _a.length; _i++) {
        var dataKey = _a[_i];
        var dataValue = value[dataKey];
        if (dataValue !== null) {
          node.dataset[dataKey] = dataValue;
        }
      }
      return;
    case "innerHTML":
    case "innerText":
    case "textContent":
      node[key] = value;
      return;
    case "spellCheck":
      node.spellcheck = value;
      return;
    case "class":
    case "className":
      node.setAttribute("class", className(value));
      return;
    case "ref":
    case "namespaceURI":
      return;
    case "style":
      if (isObject(value)) {
        __assign(node.style, value);
        return;
      }
  }
  if (isFunction(value)) {
    if (key[0] === "o" && key[1] === "n") {
      var name = key.slice(2).toLowerCase();
      listen(node, name, value);
    }
  } else if (value === true) {
    node.setAttribute(key, "");
  } else if (value !== false && value !== null) {
    node.setAttribute(key, value);
  }
}
function attributes(attr, node) {
  for (var _i = 0, _a = keys(attr); _i < _a.length; _i++) {
    var key = _a[_i];
    attribute(key, attr[key], node);
  }
  return node;
}
function listen(node, eventName, callback) {
  node.addEventListener(eventName, callback);
  return node;
}




/***/ }),

/***/ "TQ3y":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("blYT");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "UnEC":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "aCM0":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn"),
    getRawTag = __webpack_require__("uLhX"),
    objectToString = __webpack_require__("+66z");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "aGpY":
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__("1dWh");

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ "blYT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "dFKu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4XOI");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js??ref--2-3!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./search-bar.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js??ref--2-3!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./search-bar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ePw5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_abortcontroller_polyfill_dist_polyfill_patch_fetch__ = __webpack_require__("NzuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_abortcontroller_polyfill_dist_polyfill_patch_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_abortcontroller_polyfill_dist_polyfill_patch_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__ = __webpack_require__("Sn7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search_bar_scss__ = __webpack_require__("dFKu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search_bar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__search_bar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_bar_analytics__ = __webpack_require__("mPPA");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// @jsx h










var TAG = "search-bar";

var SearchBar = function (_HTMLElement) {
    _inherits(SearchBar, _HTMLElement);

    function SearchBar() {
        var _this2 = this;

        _classCallCheck(this, SearchBar);

        var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this));

        Object.defineProperty(_this, "_userInput", {
            enumerable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(_this, "_isSearchResultDisplayed", {
            enumerable: true,
            writable: true,
            value: function value() {
                return _this.eleSearchResultWrapper.style.display !== "none" ? "Yes" : "No";
            }
        });
        Object.defineProperty(_this, "_storeUserInput", {
            enumerable: true,
            writable: true,
            value: function value() {
                _this._userInput = _this.eleSearchInput.value;
                sessionStorage.setItem("userInput", _this._userInput);
            }
        });
        Object.defineProperty(_this, "_handleClearStorage", {
            enumerable: true,
            writable: true,
            value: function value(storageItem) {
                sessionStorage.removeItem(storageItem);
            }
        });
        Object.defineProperty(_this, "_handleRelatedProductsAnalytics", {
            enumerable: true,
            writable: true,
            value: function value(method, _value, displayed) {
                _this._storeUserInput();
                var analyticData = {
                    searchBarMenuDisplayed: displayed,
                    searchMethod: method,
                    selectedKeyword: _value,
                    searchId: sessionStorage.getItem("searchId"),
                    searchTerm: sessionStorage.getItem("userInput") || ""
                };
                Object(__WEBPACK_IMPORTED_MODULE_4__search_bar_analytics__["a" /* submitV2AnalyticsEvent */])("viewRelatedProductDetails", analyticData);
                _this._handleClearStorage("userInput");
                _this._handleClearStorage("analyticsData");
            }
        });
        Object.defineProperty(_this, "_handleMaxUserSearchAnalytics", {
            enumerable: true,
            writable: true,
            value: function value(event) {
                _this._userInput = event.target.value;
            }
        });
        Object.defineProperty(_this, "_handleMaxAnalytics", {
            enumerable: true,
            writable: true,
            value: function value(method, _value2, displayed) {
                _this._storeUserInput();
                var analyticsData = {
                    searchBarMenuDisplayed: displayed,
                    searchMethod: method,
                    selectedKeyword: _value2
                };
                sessionStorage.setItem('analyticsData', JSON.stringify(analyticsData));
            }
        });
        Object.defineProperty(_this, "_hideSearchResults", {
            enumerable: true,
            writable: true,
            value: function value() {
                return _this.eleSearchResultWrapper.style.display = "none";
            }
        });
        Object.defineProperty(_this, "_setupToggleSearchResult", {
            enumerable: true,
            writable: true,
            value: function value() {
                _this.eleSearchInput.addEventListener("blur", function () {
                    if (_this.dismissSearchResultTimeout) {
                        clearTimeout(_this.dismissSearchResultTimeout);
                    }
                    _this.dismissSearchResultTimeout = setTimeout(function () {
                        _this._hideSearchResults();
                    }, 300);
                });
                _this.eleSearchResultWrapper.addEventListener("focus", function () {
                    if (_this.dismissSearchResultTimeout) {
                        clearTimeout(_this.dismissSearchResultTimeout);
                    }
                });
            }
        });
        Object.defineProperty(_this, "_checkForSuggest", {
            enumerable: true,
            writable: true,
            value: function value(e) {
                if (e.keyCode !== 13) {
                    _this._onType(e.target.value);
                }
            }
        });
        Object.defineProperty(_this, "_doSearch", {
            enumerable: true,
            writable: true,
            value: function value(e) {
                e.preventDefault();
                var value = _this.eleSearchInput.value;
                if (value && value.trim()) {
                    sessionStorage.setItem("userInput", _this._userInput);
                    var urlTemplate = _this.getAttribute("data-url");
                    var url = urlTemplate.replace("##search##", encodeURIComponent(value.trim()));
                    window.location.href = url;
                }
            }
        });
        Object.defineProperty(_this, "_doSuggest", {
            enumerable: true,
            writable: true,
            value: function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_value3) {
                    var trimmedValue, result;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    trimmedValue = (_value3 || "").trim();

                                    if (!(trimmedValue.length < _this._getTriggerLength())) {
                                        _context.next = 5;
                                        break;
                                    }

                                    _this._clearResultList();
                                    _this._hideSearchResults();
                                    return _context.abrupt("return");

                                case 5:
                                    _this._abortAnyExistingRequests();
                                    result = {};
                                    _context.prev = 7;
                                    _context.next = 10;
                                    return _this._fetchSugguestResult(trimmedValue);

                                case 10:
                                    result = _context.sent;
                                    _context.next = 17;
                                    break;

                                case 13:
                                    _context.prev = 13;
                                    _context.t0 = _context["catch"](7);

                                    if (!(_context.t0.name === "AbortError")) {
                                        _context.next = 17;
                                        break;
                                    }

                                    return _context.abrupt("return");

                                case 17:
                                    _this._displaySuggestResult(result);

                                case 18:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2, [[7, 13]]);
                }));

                return function value(_x) {
                    return _ref.apply(this, arguments);
                };
            }()
        });
        Object.defineProperty(_this, "_doGetSuggestedProductImages", {
            enumerable: true,
            writable: true,
            value: function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_value4) {
                    var images;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this._fetchSuggestedProductsImages(_value4);

                                case 2:
                                    images = _context2.sent;

                                    _this._displaySuggestedImages(images);

                                case 4:
                                case "end":
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this2);
                }));

                return function value(_x2) {
                    return _ref2.apply(this, arguments);
                };
            }()
        });
        Object.defineProperty(_this, "_fetchSugguestResult", {
            enumerable: true,
            writable: true,
            value: function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_value5) {
                    var resp;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return fetch("/search/api/suggest?query=" + encodeURIComponent(_value5), {
                                        signal: _this._fetchAbort.signal,
                                        credentials: "include"
                                    });

                                case 2:
                                    resp = _context3.sent;

                                    if (!resp.ok) {
                                        _context3.next = 9;
                                        break;
                                    }

                                    _context3.next = 6;
                                    return resp.json();

                                case 6:
                                    return _context3.abrupt("return", _context3.sent);

                                case 9:
                                    throw resp.status;

                                case 10:
                                case "end":
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this2);
                }));

                return function value(_x3) {
                    return _ref3.apply(this, arguments);
                };
            }()
        });
        Object.defineProperty(_this, "_abortAnyExistingRequests", {
            enumerable: true,
            writable: true,
            value: function value() {
                _this._fetchAbort.abort();
                _this._fetchAbort = new window.AbortController();
            }
        });
        Object.defineProperty(_this, "_getTriggerLength", {
            enumerable: true,
            writable: true,
            value: function value() {
                var length = parseInt(_this.getAttribute("trigger-length"));
                return isNaN(length) || length <= 0 ? 3 : length;
            }
        });
        Object.defineProperty(_this, "_clearSearch", {
            enumerable: true,
            writable: true,
            value: function value() {
                _this.eleSearchInput.value = "";
            }
        });
        Object.defineProperty(_this, "_clearResultList", {
            enumerable: true,
            writable: true,
            value: function value() {
                _this.eleSuggestedKeywordsDiv.style.display = "none";
                _this.eleSuggestedKeywordsList.innerHTML = "";
                _this.eleSuggestedBrandsDiv.style.display = "none";
                _this.eleSuggestedBrandsList.innerHTML = "";
                _this.eleSuggestedProductsDiv.style.display = "none";
                _this.eleSuggestedProductsList.innerHTML = "";
                _this.eleSuggestedCategoriesDiv.style.display = "none";
                _this.eleSuggestedCategoriesList.innerHTML = "";
            }
        });
        Object.defineProperty(_this, "_showAndMapResults", {
            enumerable: true,
            writable: true,
            value: function value(result) {
                return function (key, eleDiv, eleList, mappingFunction) {
                    if (result[key] && result[key].length > 0) eleDiv.style.display = "block";else eleDiv.style.display = "none";

                    (result[key] || []).map(mappingFunction).forEach(function (e) {
                        return eleList.appendChild(e);
                    });
                };
            }
        });
        Object.defineProperty(_this, "_displaySuggestResult", {
            enumerable: true,
            writable: true,
            value: function value(result) {
                if (result) {
                    _this._clearResultList();
                    var mapper = _this._showAndMapResults(result);

                    mapper("suggestedKeywords", _this.eleSuggestedKeywordsDiv, _this.eleSuggestedKeywordsList, function (s) {
                        return Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                            "li",
                            { "class": "search-result__list-item--text" },
                            Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                                "a",
                                { href: s.url, onClick: function onClick() {
                                        _this._handleMaxAnalytics("Suggested search", s.keyword, _this._isSearchResultDisplayed());
                                    } },
                                s.keyword
                            )
                        );
                    });

                    mapper("suggestedBrands", _this.eleSuggestedBrandsDiv, _this.eleSuggestedBrandsList, function (s) {
                        return Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                            "li",
                            { "class": "search-result__list-item--text" },
                            Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                                "a",
                                { href: s.url, onClick: function onClick() {
                                        _this._handleMaxAnalytics("Brands", s.title, _this._isSearchResultDisplayed());
                                    } },
                                s.title
                            )
                        );
                    });

                    mapper("suggestedCategories", _this.eleSuggestedCategoriesDiv, _this.eleSuggestedCategoriesList, function (c) {
                        return Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                            "li",
                            { "class": "search-result__list-item--text" },
                            Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                                "a",
                                { href: c.url, onClick: function onClick() {
                                        _this._handleMaxAnalytics("Categories", c.suggestedKeyword + " in " + c.title, _this._isSearchResultDisplayed());
                                    } },
                                c.suggestedKeyword,
                                " in ",
                                c.title
                            )
                        );
                    });

                    mapper("suggestedProducts", _this.eleSuggestedProductsDiv, _this.eleSuggestedProductsList, function (r) {
                        return Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                            "li",
                            { "class": "search-result__list-item--block" },
                            Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                                "a",
                                { "class": "search-result__list-item-img", href: r.url, onClick: function onClick() {
                                        _this._handleRelatedProductsAnalytics("Related products", r.title, _this._isSearchResultDisplayed());
                                    } },
                                Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])("img", {
                                    src: "/product/static/images/w280-image-unavailable.jpg",
                                    alt: r.title,
                                    "data-search-image-product-code": r.productCode
                                })
                            ),
                            Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                                "div",
                                { "class": "search-result__list-item-name" },
                                r.title
                            )
                        );
                    });

                    _this.eleSearchResultWrapper.style.display = "block";

                    result.suggestedProducts ? _this._doGetSuggestedProductImages(result.suggestedProducts) : null;
                }
            }
        });
        Object.defineProperty(_this, "_displaySuggestedImages", {
            enumerable: true,
            writable: true,
            value: function value(result) {
                if (result) {
                    Object.keys(result.images).map(function (productCode) {
                        //  Assume first image should be displayed
                        if (result.images[productCode][0].resolutions.w280.url) {
                            _this._setSuggestedProductImage(productCode, result.images[productCode][0].resolutions.w280.url);
                        }
                    });
                }
            }
        });
        Object.defineProperty(_this, "_fetchSuggestedProductsImages", {
            enumerable: true,
            writable: true,
            value: function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_value6) {
                    var headers, body, resp;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    headers = new Headers({
                                        "Content-Type": "application/json;charset=UTF-8"
                                    });
                                    body = JSON.stringify(_value6.map(function (n) {
                                        return parseInt(n.productCode, 10);
                                    }));
                                    _context4.next = 4;
                                    return fetch("/trsonline/products/images/batch", {
                                        method: "POST",
                                        credentials: "include",
                                        headers: headers,
                                        body: body
                                    });

                                case 4:
                                    resp = _context4.sent;

                                    if (!resp.ok) {
                                        _context4.next = 11;
                                        break;
                                    }

                                    _context4.next = 8;
                                    return resp.json();

                                case 8:
                                    return _context4.abrupt("return", _context4.sent);

                                case 11:
                                    throw resp.status;

                                case 12:
                                case "end":
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this2);
                }));

                return function value(_x4) {
                    return _ref4.apply(this, arguments);
                };
            }()
        });
        Object.defineProperty(_this, "_setSuggestedProductImage", {
            enumerable: true,
            writable: true,
            value: function value(productCode, imageURL) {
                var elem = _this.eleSuggestedProductsList.querySelector("[data-search-image-product-code='" + productCode + "']");
                if (elem) {
                    elem.setAttribute("src", imageURL);
                }
            }
        });
        Object.defineProperty(_this, "_populateSearchTerm", {
            enumerable: true,
            writable: true,
            value: function value() {
                var location = /(^\/search\/)/.test(window.location.pathname);
                var queryParams = window.location.search.match(/[?&]query=([^&#]*)/);
                if (location && queryParams && queryParams.length > 0 && queryParams[1]) {
                    _this.eleSearchInput.value = decodeURIComponent(queryParams[1]);
                }
            }
        });

        var debounceTime = _this.getAttribute("debounce");
        _this._onType = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function (value) {
            _this._doSuggest(value);
        }, debounceTime || 300);
        _this._fetchAbort = new window.AbortController();
        return _this;
    }

    _createClass(SearchBar, [{
        key: "connectedCallback",
        value: function connectedCallback() {
            var _this3 = this;

            this.classList.add("header-main__search-wrapper");
            this.appendChild(Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                "form",
                { "class": "header-main__search", onSubmit: this._doSearch },
                Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])("input", {
                    type: "text",
                    id: "search-input",
                    "class": "header-main__search-input",
                    placeholder: "Search for products...",
                    ref: function ref(r) {
                        return _this3.eleSearchInput = r;
                    },
                    autoComplete: "off",
                    onKeyUp: this._checkForSuggest,
                    onKeyDown: function onKeyDown(event) {
                        _this3._handleMaxUserSearchAnalytics(event);
                    }
                }),
                Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                    "svg",
                    {
                        id: "header-main-search-clear",
                        "class": "header-main__search-clear",
                        onClick: this._clearSearch,
                        viewBox: "0 0 50 50"
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                        "g",
                        null,
                        Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])("path", { d: "M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z " })
                    )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                    "button",
                    { "class": "header-main__search-button", type: "submit", onClick: function onClick() {
                            _this3._handleMaxAnalytics("Search bar", null, _this3._isSearchResultDisplayed());
                        } },
                    "Search"
                )
            ));
            this.appendChild(Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                "div",
                {
                    id: "search-results",
                    "class": "search-result-wrapper",
                    ref: function ref(r) {
                        return _this3.eleSearchResultWrapper = r;
                    }
                },
                Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                    "div",
                    {
                        "class": "search-result__section",
                        ref: function ref(r) {
                            return _this3.eleSuggestedKeywordsDiv = r;
                        }
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                        "h4",
                        { "class": "search-result__section-title" },
                        "Suggested search"
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])("ul", {
                        "class": "search-result__list--text",
                        ref: function ref(r) {
                            return _this3.eleSuggestedKeywordsList = r;
                        }
                    })
                ),
                Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                    "div",
                    {
                        "class": "search-result__section",
                        ref: function ref(r) {
                            return _this3.eleSuggestedBrandsDiv = r;
                        }
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                        "h4",
                        { "class": "search-result__section-title" },
                        "Brands"
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])("ul", {
                        "class": "search-result__list--text",
                        ref: function ref(r) {
                            return _this3.eleSuggestedBrandsList = r;
                        }
                    })
                ),
                Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                    "div",
                    {
                        "class": "search-result__section",
                        ref: function ref(r) {
                            return _this3.eleSuggestedCategoriesDiv = r;
                        }
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                        "h4",
                        { "class": "search-result__section-title" },
                        "Categories"
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])("ul", {
                        "class": "search-result__list--text",
                        ref: function ref(r) {
                            return _this3.eleSuggestedCategoriesList = r;
                        }
                    })
                ),
                Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                    "div",
                    {
                        "class": "search-result__section",
                        ref: function ref(r) {
                            return _this3.eleSuggestedProductsDiv = r;
                        }
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                        "h4",
                        { "class": "search-result__section-title" },
                        "Related Products"
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])("ul", {
                        "class": "search-result__list--block",
                        ref: function ref(r) {
                            return _this3.eleSuggestedProductsList = r;
                        }
                    })
                ),
                Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                    "form",
                    { onSubmit: this._doSearch },
                    Object(__WEBPACK_IMPORTED_MODULE_2__common_jsx_dom_svg_js__["a" /* h */])(
                        "button",
                        {
                            "class": "header-main__search-button--results",
                            type: "submit",
                            onClick: function onClick() {
                                return _this3._handleMaxAnalytics("Show all products", null, _this3._isSearchResultDisplayed());
                            }
                        },
                        "Show All Results"
                    )
                )
            ));
            this._setupToggleSearchResult();
            this._populateSearchTerm();
        }
    }]);

    return SearchBar;
}(HTMLElement);

customElements.define(TAG, SearchBar);

/***/ }),

/***/ "kxzG":
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__("aGpY"),
    isObject = __webpack_require__("yCNF"),
    isSymbol = __webpack_require__("6MiT");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "mJPh":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "mPPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAnalyticsV2Proxy */
/* unused harmony export createAnalyticsEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submitV2AnalyticsEvent; });
var getAnalyticsV2Proxy = function getAnalyticsV2Proxy() {
    window.maxAnalyticsEventsV2 = window.maxAnalyticsEventsV2 || [];
    return window.maxAnalyticsEventsV2;
};

var createAnalyticsEvent = function createAnalyticsEvent(eventName, eventData) {
    return new CustomEvent("maxAnalyticsEvent", {
        detail: {
            eventName: eventName,
            page: window.location.pathname,
            eventData: eventData
        }
    });
};

var submitV2AnalyticsEvent = function submitV2AnalyticsEvent(eventName, eventData) {
    var analyticsEvent = createAnalyticsEvent(eventName, eventData);
    getAnalyticsV2Proxy().push(analyticsEvent);
};

/***/ }),

/***/ "uLhX":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "yCNF":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ })

/******/ });


// WEBPACK FOOTER //
// hashed/js/search-bar.162cd2fa8cc191ab4000.js